<template>
  <div>
    <a-row class="title">
      <a-col :span="6" class="height-full">
        <tk-flex middle center class="height-full">
          序号
        </tk-flex>
      </a-col>
      <a-col :span="8" class="height-full">
        <tk-flex middle center class="height-full">
          状态
        </tk-flex>
      </a-col>
      <a-col :span="8" class="height-full">
        <tk-flex middle center class="height-full">
          异常时间
        </tk-flex>
      </a-col>
    </a-row>
    <a-empty style="padding-top: 30px;" v-if="datas.length === 0"></a-empty>
    <div v-else style="overflow-y: auto;" :style="{maxHeight: height + 'px'}">
      <a-row style="height: 48px" v-for="(item, index) in datas" :key="index">
      <a-col :span="6" class="height-full">
        <tk-flex middle center class="height-full">
          {{ index + 1 }}
        </tk-flex>
      </a-col>
      <a-col :span="8" class="height-full">
        <tk-flex middle center class="height-full">
          <div class="error-status">异常</div>
        </tk-flex>
      </a-col>
      <a-col :span="8" class="height-full">
        <tk-flex middle center class="height-full">
          {{ formatTime(item.time) }}
        </tk-flex>
      </a-col>
    </a-row>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      datas: [],
      height: 200
    }
  },
  mounted () {
    this.getDatas()
    this.height = window.outerHeight * 0.5
  },
  computed: {
    tableList () {
      return this.datas.map((element, index) => ({
        objectId: element.objectId,
        index: index + 1,
        key: index + 1,
        status: '异常',
        time: moment(element.time).format('YYYY/MM/DD HH:mm')
      }))
    }
  },
  methods: {
    formatTime (time) {
      return moment(time).format('YYYY/MM/DD HH:mm')
    },
    async getDatas () {
      this.loading = true
      const res = await this.$tkParse.get('/classes/eqErrorLog', {
        params: {
          where: {
            eqId: this.id
          },
          order: '-createdAt',
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.datas = res.data.results
      this.loading = false
    }
  }
}
</script>
<style scoped>
.title {
  background-color: #f4f6f8;
  border-radius: 8px;
  height: 48px;
  color: #363b45;
  font-size: 14PX;
}
.error-status{
  padding: 2px 4px;
  color: #FE2A58;
  border: 1px solid #FE2A58;
  border-radius: 6px;
}
</style>
